const localisations = {
    layout: {
        applicationTitle: "Stock Ledger",
    },
    pages: {
        home: {
            heading: "Home",
        },
        sandbox: {
            heading: "Sandbox",
            currentlySelected: "Currently Selected",
        },
        createpartition: {
            heading: "Create Partition",
        },
        editPartition: {
            heading: "Edit Partition",
        },
        showPartition: {
            heading: "Partition Details",
            coreDetailsHeading: "Details:",
            currentAllocationsHeading: "Stock currently allocated to Partition:",
            allocationHistoryHeading: "Partition stock allocation history:",
            editButton: "Edit",
        },
        partitions: {
            heading: "View Partitions",
            blurb: "A Partition is a logical representation of a quantity of stock and is primarily used to represent a project, although it can also be used to represent surplus stock.",
        },
        createPreAlert: {
            heading: "Create Pre-Alert",
        },
        environmentConfig: {
            heading: "Environment Config Values",
            blurb: "This page shows the values of each environment config set within the React App.",
            table: {
                variableKeyHeading: "Key",
                valueHeading: "Value",
            },
            values: {
                environment: "Environment",
                buildNumber: "Build number",
                partitionsApiUrl: "Partition Api url",
                productsApiUrl: "Products Api url",
                allocationsApiUrl: "Allocations Api url",
                IncomingStockNotificationApiUrl: "Incoming Stock Notification Api url",
                legacyIntegrationApiUrl: "Legacy Integration Api url",
                vodafoneStockTransferImportApiUrl: "Vodafone Stock Transfer Import Api url",
                authDomain: "Auth domain",
                fieldCompanyNamespace: "Field Company Namespace",
            },
        },
        adjustmentAllocation: {
            heading: "Adjust Stock",
        },
        movementAllocation: {
            heading: "Transfer Stock",
        },
        stockTransferImport: {
            heading: "Stock Transfer Import",
        },
        manageNodes: {
            heading: "Manage Nodes",
        },
        manageProducts: {
            heading: "Add 'Partition-Managed' Products"
        },
        product: {
            heading: "Product Search",
            blurb: "Search and select a partition-managed product to view the quantities of stock currently allocated to each partition"
        },
        consistencyCheck: {
            heading: "Consistency Check",
            blurb: 'The exception report records products that have higher or lower levels of stock in the Stock Ledger than in Thinventory Warehouse.',  
            reportCreationDateBlurb: "Last Updated: ",
            errorMessage: "An error has occurred. Please contact Application Support",
            warningMessage: "An error has occurred, and the report has not been updated for several days"
        }
    },
    navigation: {
        home: "Home",
        partitions: "View Partitions",
        sandbox: "Sandbox",
        createPartition: "Create Partition",
        signOut: "Sign out",
        environmentConfig: "Environment config",
        adjustmentAllocation: "Adjust Stock",
        movementAllocation: "Transfer Stock",
        createPreAlert: "Create Pre-Alert",
        StockTransferImport: "Stock Transfer Imports",
        manageNodes: "Manage Nodes",
        productSearch: "Product Search",
        consistencyCheck: "Exception Report"
    },
    components: {
        footer: {
            example: "footer",
        },
        fieldCompany: {
            fieldCompanyIdLabel: "Field Company ID",
        },
    },
    services: {
        fieldCompanyService: {
            noNamespaceInConfigText: "No namespace has been set in configuration.",
            noFieldCompanyForLoggedInUserText: "No field companies are set for the logged in user.",
            moreThanOneFieldCompanyText: `There are multiple field companies associated to the logged in user, we will use __fieldCompanyId__ for all requests.`,
        },
    },
};

export default localisations;
